import script from "./CustomCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=44542db5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44542db5"]])

export default __exports__